import { weekdayName } from '../../i18n/calendarLabels';
import { displayDate, displayDateTime } from '../common/datePresentation';
import React from "react";
import PropTypes from "prop-types";
import AttendanceActionsMenu from "./AttendanceActionsMenu";
import { useTranslation } from 'react-i18next';

function AttendanceLessonHeader({ canUndoWholeLessonCancellation, canEditAllLessons, viewModel, onAction }) {
  const { t: tr, i18n } = useTranslation();
  const lessonTime = viewModel.endTime
    ? `${viewModel.lessonDetails.startTime}-${viewModel.endTime}`
    : viewModel.lessonDetails.startTime;

  return (
    <>
      <h2 className="attendance-page__title">{`${weekdayName(viewModel.lessonDetails.dayOfWeek, i18n.language)}, ${displayDate(viewModel.lessonDetails.date, i18n.language)} - ${viewModel.classTypeName}`}</h2>
      {viewModel.lessonDetails.attendanceCheckedAt && (
        <p className="text-muted">
          {tr('manage:attendanceCheckedAtLabel')}{' '}
          <time dateTime={viewModel.lessonDetails.attendanceCheckedAt}>
            {displayDateTime(new Date(viewModel.lessonDetails.attendanceCheckedAt), i18n.language)}
          </time>
        </p>
      )}
      <div className="attendance-page__context">
        <div className="attendance-page__context-item attendance-page__context-item--time">
          <span className="attendance-page__context-icon" aria-hidden="true">
            <i className="far fa-clock" />
          </span>
          <div>
            <span>{tr("calendar:time")}</span>
            <strong>{lessonTime}</strong>
          </div>
        </div>
        <div>
          <span>{tr("manage:teacher_9")}</span>
          <strong>{viewModel.teacherName}</strong>
        </div>
        {viewModel.schoolClass.comment && (
          <div>
            <span>{tr("manage:roomNotes_46")}</span>
            <strong>{viewModel.schoolClass.comment}</strong>
          </div>
        )}
        <div>
          <span>{tr("manage:levelCourse_47")}</span>
          <strong>{viewModel.classTypeName}</strong>
        </div>
        <AttendanceActionsMenu
          canEditAllLessons={canEditAllLessons}
          canUndoWholeLessonCancellation={canUndoWholeLessonCancellation}
          onAction={onAction}
        />
      </div>
    </>
  );
}

AttendanceLessonHeader.propTypes = {
  canUndoWholeLessonCancellation: PropTypes.bool,
  canEditAllLessons: PropTypes.bool,
  viewModel: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired,
};

AttendanceLessonHeader.defaultProps = {
  canUndoWholeLessonCancellation: false,
  canEditAllLessons: false,
};

export default AttendanceLessonHeader;
